import React, {Component} from 'react';
import PropTypes from 'prop-types';
import MyImages from '../components/MyImages';
import {connect} from 'react-redux';
import {
    fetchImagesAndUser,
    onDeleteSelection,
    onDownloadSelection,
    onPrintSelection,
    onResetSelection, onSearchInputValueChange,
    onSearchTermChange,
    onSortByChange,
    onToggleSelectImage,
} from '../actions/ImageActions';
import isEmpty from 'lodash/isEmpty';
import {SelectionToolbar} from '../components/SelectionToolbar';
import {withRouter} from 'react-router-dom';
import {hasOpenModal as hasOpenModalInternal} from '../reducers/modals';
import Loading from '../components/Loading';
import FileUploadContainer from './FileUploadContainer';
import {getFilteredAndSortedImages, getSortedSelectedImages} from '../reducers/imagesSelector';
import {getFetchStatus, getUser} from '../reducers/users';

@withRouter
@connect(
    state => ({
        currentUser: state.auth.currentUser,
        myImagesSettings: state.myImagesSettings,
        images: getFilteredAndSortedImages(state),
        openImage: state.openImage,
        user: getUser(state),
        sortedSelectedImages: getSortedSelectedImages(state),
        hasOpenModal: () => hasOpenModalInternal(state.modals),
        fetchStatus: getFetchStatus(state),
    }),
    {
        onSearchTermChange,
        onSearchInputValueChange,
        onSortByChange,
        fetchImagesAndUser,
        onToggleSelectImage,
        onResetSelection,
        onDeleteSelection,
        onPrintSelection,
        onDownloadSelection,
    }
)
export default class MyImagesContainer extends Component {
    static propTypes = {
        match: PropTypes.shape({
            params: PropTypes.shape({
                userId: PropTypes.string
            }),
            url: PropTypes.string,
        }),
        myImagesSettings: PropTypes.shape({
            searchInputValue: PropTypes.string,
            sortBy: PropTypes.string,
        }),
        images: PropTypes.array,
        onSearchTermChange: PropTypes.func,
        onSearchInputValueChange: PropTypes.func,
        onSortByChange: PropTypes.func,
        onUploadsSelected: PropTypes.func,
        onUploadStarted: PropTypes.func,
        onUploadError: PropTypes.func,
        onUploadProgress: PropTypes.func,
        onUploadFinished: PropTypes.func,
        fetchImagesAndUser: PropTypes.func,
        openImage: PropTypes.object,
        currentUser: PropTypes.object,
        user: PropTypes.object,
        sortedSelectedImages: PropTypes.array,
        onToggleSelectImage: PropTypes.func,
        onResetSelection: PropTypes.func,
        onDeleteSelection: PropTypes.func,
        onDownloadSelection: PropTypes.func,
        onPrintSelection: PropTypes.func,
        onSectionNavToggle: PropTypes.func,
        history: PropTypes.object,
        hasOpenModal: PropTypes.func,
        fetchStatus: PropTypes.object,
    };

    componentWillMount() {
        this.fetch(this.props);
    }

    componentWillReceiveProps(nextProps) {
        if (nextProps.match.params.userId !== this.props.match.params.userId) {
            this.fetch(nextProps);
        }
    }

    getUserId = (props) => {
        const userId = props.match.params.userId;
        if (userId !== 'my') {
            return Number(userId);
        }
        return props.currentUser.id;
    };

    fetch = (props) => {
        const userId = this.getUserId(props);
        props.fetchImagesAndUser(userId);
    };

    handleOpen = () => {
        this.fileUpload.open();
    };

    render() {
        const {images, myImagesSettings, openImage, user, sortedSelectedImages, fetchStatus, history} = this.props;
        if (isEmpty(user)) {
            return false;
        }
        if (fetchStatus.fetching) {
            return <Loading style={{fontSize: '300%', textAlign: 'center'}}/>;
        }

        const {searchInputValue, sortBy} = myImagesSettings;
        const {usageLimit, currentUsage} = user;
        const hasFileUpload = usageLimit < 0 || currentUsage < usageLimit;

        return (
            <FileUploadContainer
                uploadContext="imagepop"
                fileUploadRef={c => this.fileUpload = c}
            >
                <SelectionToolbar
                    selectedImages={sortedSelectedImages}
                    onResetSelection={this.props.onResetSelection}
                    onDeleteSelection={this.props.onDeleteSelection}
                    onPrintSelection={this.props.onPrintSelection}
                    onDownloadSelection={this.props.onDownloadSelection}
                    history={history}
                />
                <div className="page">
                    <div className="images-content">
                        <div className="card">
                            <MyImages
                                images={images}
                                usageLimit={usageLimit}
                                currentUsage={currentUsage}
                                onOpenUpload={hasFileUpload ? this.handleOpen : null}
                                searchInputValue={searchInputValue}
                                onSearchTermChange={this.props.onSearchTermChange}
                                onSearchInputValueChange={this.props.onSearchInputValueChange}
                                sortBy={sortBy}
                                onSortByChange={this.props.onSortByChange}
                                lastVisitedId={user.id === openImage.userId ? openImage.lastVisitedId : null}
                                selectedImages={sortedSelectedImages}
                                onToggleSelectImage={this.props.onToggleSelectImage}
                                onResetSelection={this.props.onResetSelection}
                                hasOpenModal={this.props.hasOpenModal}
                            />
                        </div>
                    </div>
                </div>
            </FileUploadContainer>
        );
    }
}



// WEBPACK FOOTER //
// ./src/containers/MyImagesContainer.js